<template>
    <RedesignFormItem :label="$t('layout.config.widgetTableContentFontSize')">
        <RedesignInputNumber
            v-model="model"
            :max-value="optionConfigs.WidgetTableContentFontSize.max"
            :min-value="optionConfigs.WidgetTableContentFontSize.min"
            :step="optionConfigs.WidgetTableContentFontSize.step"
            size="small"
            placeholder="0"
        />
    </RedesignFormItem>
</template>

<script setup lang="ts">
import RedesignFormItem from '@/components/RedesignBaseComponents/Form/RedesignFormItem.vue'
import RedesignInputNumber from '@/components/RedesignBaseComponents/Inputs/RedesignInputNumber.vue'
import { computed } from 'vue'
import { optionConfigs } from '@/views/DashboardSettings/LayoutManagement/layout-management'
import { widgetTableContentFontSize } from '@/composables/globalData/useLayouts'

const props = defineProps<{
    value?: string
}>()

const emit = defineEmits([ 'input' ])

const model = computed({
    get () {
        return stringValueToNumber(stringValue.value)
    },
    set (val) {
        emit('input', numberValueToString(val))
    }
})


const hasOwnValue = computed(() => {
    return props.value !== undefined
})

const layoutConfig = computed(() => {
    return widgetTableContentFontSize.value
})

const stringValue = computed(() => {
    if (hasOwnValue.value) {
        return props.value || ''
    } else {
        return layoutConfig.value?.fontSize
    }
})

/* Methods */
function stringValueToNumber (value: string) {
    return parseInt(value.replace('px', ''))
}
function numberValueToString (value: number) {
    return `${value}px`
}
</script>

